document.addEventListener('turbolinks:load', () => {
  loadCustomElement('autopay-settings', import('./elements/autopay_settings_element'));
});

function loadCustomElement(selector, callback) {
  const element = document.querySelector(selector);
  if (!element) return;
  callback;
}
